/*-- Scroll Up/Down add class --*/
var lastScrollTop = 0;
$(window).scroll(function(event){
   var st = $(this).scrollTop();
   if (st > lastScrollTop){
     $('#shopify-section-header').addClass('scrolling_down');
     $('#shopify-section-header').removeClass('scrolling_up');
   } else {
     $('#shopify-section-header').addClass('scrolling_up');
     $('#shopify-section-header').removeClass('scrolling_down');
   }
   lastScrollTop = st;
});

$( document ).ready(function() {

  /*setTimeout(function () {
    $(".large--text-left a.tmenu_item_link").click(function(){
      if ($(this).parent().find(".close_icon").length === 0) {
        $(this).parent().append("<span class='close_icon'>X</span>");
      } else {
        $(".close_icon").remove();
      }
    });
    
    $("span.close_icon").click(function(){
      $(this).parent().find(".tmenu_item_link").click();
    });
  }, 1000);*/
  
  

  setTimeout(function () {
    var distance = $('.product-single__add-to-cart').offset().top + 55;
    $window = $(window);
    $window.scroll(function() {
      if ( $window.scrollTop() > distance ) {
        $('.product-single__add-to-cart').addClass("btn_fixed");
      }
      else {
        $('.product-single__add-to-cart').removeClass("btn_fixed");
      }
    });
  }, 1000);

  var distance_2 = $('#shopify-section-header').offset().top;
  $window_2 = $(window);
  $window_2.scroll(function() {
    if ( $window_2.scrollTop() > distance_2 ) {
      $('#shopify-section-header').removeClass("window_top");
    }
    else {
      $('#shopify-section-header').addClass("window_top");
    }
  });


   var win_height = $( window ).height();
   var scroll_height = win_height - 168;
    console.log( win_height );
    console.log( scroll_height );

    $(".template_details .custom_single_product_meta").css("height", scroll_height);
    $(".template_new .custom_single_product_meta").css("height", scroll_height);

    $('.image_popup').click(function(){
      $('#popup_images').toggle();
      $('body').toggleClass('popup_on');

      var data_id = $( this ).attr( "data_id" );
        $('#popup_images').animate({
          scrollTop: $('#'+data_id).position().top
        }, 0);
    });

    $('.close_btn').click(function(){
      $('#popup_images').toggle();
      $('body').toggleClass('popup_on');
    });

    if($( window ).width() < 999) {
        $('.panel-collapse').on('shown.bs.collapse', function (e) {
            var $panel = $(this).closest('.panel');
            $('html,body').animate({
                scrollTop: $panel.offset().top - 98
            }, 500); 
        });
    }

    /*setTimeout(function () {
      var bn_height = $(".banner_content").height();
      console.log(bn_height);
      $(".dark_theme .banner_image").css("min-height", bn_height);
      $(".dark_theme .banner_image img").css("min-height", bn_height);
    }, 1000);*/
  
  if($( window ).width() < 1025) {
    var banner_height = win_height - 98;
  	$(".home_banner.dark_theme").css("min-height", banner_height);
  }


      
        $('.customer_testimonial .content').slick({
          
          arrows: true,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0551/9091/3155/files/lftsvg.svg?v=1661361061'></button>",
          nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0551/9091/3155/files/right-svg.svg?v=1661361061'></button>",
          responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '30px',
            }
          }  
          ]
        });
      

});

jQuery(window).load(function(){
   temph_1=0;
   jQuery('.eqh_1').each(function(){
      maxh_1 = jQuery(this).height();
      if(maxh_1 > temph_1) {
         temph_1 = maxh_1;
      }
   });
   jQuery('.eqh_1').height(temph_1);
});


